<template>
  <div class="bg">
    <a-card :title="$t('edit.settings.setsTitle')" :bordered="false">
      <a-row style="margin: 20px 0">
        <a-form-model ref="ruleForm" :form="form" :rules="rules" :model="form">
          <a-form-model-item>
            <a-col :span="6">
              <span>{{ $t('tour.msg.title') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidecomment" @change="value => handleChange(value, 'hidecomment')" />
            </a-col>

            <a-col :span="6">
              <span>{{ $t('descriptions.views') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidebrowse" @change="value => handleChange(value, 'hidebrowse')" />
            </a-col>
            <a-col :span="6">
              <span>{{ $t('common.sceneSelect') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidechoose" @change="value => handleChange(!value, 'hidechoose')" />
            </a-col>
            <a-col :span="6">
              <span>{{ $t('actionTitles.share') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hideshare" @change="value => handleChange(value, 'hideshare')" />
            </a-col>
          </a-form-model-item>
        </a-form-model>
      </a-row>

      <a-row :gutter="[0, 40]">
        <a-form-model ref="ruleForm" :form="form" :rules="rules" :model="form">
          <a-form-model-item>
            <a-col :span="6">
              <span>{{ $t('descriptions.music') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidebgm" @change="value => handleChange(value, 'hidebgm')" />
            </a-col>
            <a-col :span="6">
              <span>VR：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidevr" @change="value => handleChange(value, 'hidevr')" />
            </a-col>
            <a-col :span="6">
              <span>{{ $t('edit.settings.fullScreen') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidefullscreen" @change="value => handleChange(value, 'hidefullscreen')" />
            </a-col>
            <a-col :span="6">
              <span>{{ $t('edit.settings.authInfo') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hideuser" @change="value => handleChange(value, 'hideuser')" />
            </a-col>
          </a-form-model-item>
        </a-form-model>
      </a-row>
      <a-row :gutter="[0, 40]">
        <a-form-model ref="ruleForm" :form="form" :rules="rules" :model="form">
          <a-form-model-item>
            <a-col :span="6">
              <span>{{ $t('descriptions.speck') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hidebgv" @change="value => handleChange(value, 'hidebgv')"/>
            </a-col>
            <a-col :span="6">
              <span>{{ $t('descriptions.autoRotate') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.auto_rotate" @change="value => handleChange(value, 'hidebgv')" />
            </a-col>
            <a-col :span="6">
              <span>{{ $t('descriptions.introduce') }}：</span>
              <a-switch :checked-children="$t('enum.switch.1')" :un-checked-children="$t('enum.switch.0')"
                v-model="form.hideintroduce" @change="value => handleChange(value, 'hidebgv')" />
            </a-col>
          </a-form-model-item>
        </a-form-model>
      </a-row>
      <a-row style="margin-top:40px">
        <a-col span="8">
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit">
                {{ $t('actionTitles.submit')}}
              </a-button>
              <a-button style="margin-left: 10px;" @click="handleCancel">{{ $t('actionTitles.cancel') }}</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: { ...mapGetters(["vrbase", "userInfo"]) },
  created() {
    // this.setStoreToForm(this.vrbase.sets);
  },
  data() {
    return {
      form: {
        hidechoose: false,
        hidecomment: false,
        hidebrowse: false,
        hideshare: false,
        hidebgm: false,
        hidebgv: false,
        hidevr: false,
        hidefullscreen: false,
        hideuser: false,
        auto_rotate: false,
        hideintroduce: false,
      },
      rules: {},
    };
  },
  created() {
    let setObj = this.$deepClone(this.vrbase.sets);
    let form = {};
    for (let i in setObj) {
      for (let j in this.form) {
        if (i === j) {
          form[i] = !Boolean(setObj[i]);
        }
      }
    }
    this.form = form;
    console.log("FunctionView form =>", this.form);
  },
  methods: {
    handleChange(value, option) {
      this.form = Object.assign({}, this.form, { option: !value });
    },
    handleSubmit() {
      let form = {};
      for (let i in this.form) {
        if (this.form[i]) {
          form[i] = 0;
        } else {
          form[i] = 1;
        }
      }
      this.$refs.ruleForm.validate((valid) => {
        const vrbase = {
          ...this.vrbase,
          sets: { ...this.vrbase.sets, ...form },
        }
        this.$store
          .dispatch("saveVRBase", { vrbase, showLoading: true, })
          .then(() => { });
      });
    },
    handleCancel() {
      // this.setStoreToForm(this.vrbase.sets);
    },
  },
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 10px;
}

.submitBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}

.submitBtn:hover {
  background-color: #d485ff;
  border-color: #d485ff;
}

.submitBtn:focus {
  background-color: #d485ff;
  border-color: #d485ff;
}

.specialSwitch {
  background-color: #b52bff;
}
</style>